import { IBusinessPromotionStatus } from "../../../interfaces/businessPromotionStatus.interface";
import { IPromotion } from "../../../interfaces/promotion.interface";

export function sortPromotionsByAbc(promotions: IPromotion[]) {
  return promotions.sort((a: IPromotion, b: IPromotion) =>
    a.businessName.localeCompare(b.businessName)
  );
}
